'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const styleEncapsulation = require('@zapier/style-encapsulation');
const react = require('@emotion/react');
const React = require('react');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const breakpoints = {
  tablet: 768,
  desktop: 1230
};
const Styles = styleEncapsulation.labelStyles("BlockGrid", {
  root: ({ childrenLength, maxColumns, maxWidth }) => react.css`
    ${styleMixins_reset.boxSizing};
    display: grid;
    align-items: flex-start;
    gap: 50px 30px;
    max-width: ${maxWidth}px;
    margin: auto;
    grid-template-columns: repeat(${childrenLength}, 1fr);

    // Two columns if tablet and two children, otherwise one column.
    @media screen and (max-width: ${breakpoints.desktop}px) {
      grid-template-columns: repeat(
        ${childrenLength === 2 || maxColumns === 2 ? 2 : 1},
        1fr
      );
    }

    // One column if mobile
    @media screen and (max-width: ${breakpoints.tablet}px) {
      grid-template-columns: repeat(1, 1fr);
    }
  `
});
const BlockGrid = ({ children, maxColumns, maxWidth = 1170 }) => {
  const childrenLength = maxColumns || React.Children.toArray(children).length;
  return react.jsx("div", { css: Styles.root({ childrenLength, maxColumns, maxWidth }), "data-zds": true }, children);
};

exports.BlockGrid = BlockGrid;
//# sourceMappingURL=BlockGrid.cjs.js.map
